import type { ContentTestimonial } from "@/types/content";
import TestimonialCard from "@/components/feature/TestimonialCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function VoiceSection({ testimonials }: { testimonials: ContentTestimonial[] }) {
  return (
    <section className="w-full bg-background-200/50 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="Voices"
          title="大家眼里的瓜田"
          description="来自长期活跃用户的真实反馈，也是我们持续整理话题的动力。"
        />

        <div className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <TestimonialCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}